export default __webpack_public_path__ + "static/media/factor_left_bg.d29a0648.png";